module.exports = __webpack_public_path__ + "img/warning.e9a68b99.svg";